import { useReducedMotion } from 'framer-motion'

import Lottie from '@/components/lottie'

import DiamondsRight from '../graphics/diamonds-right'
import Section from '../components/section'
import Stat from '../components/stat'
import { cx } from '@/utils/strings'

type StatsProps = {
  heading: string
  items: {
    value: number
    valueUnit?: string
    stat: string | React.ReactNode
    lottieUrl: string
    counterDuration: number
    counterDelay: number
    fraction?: string
  }[]
}

export default function Stats({ heading, items = [] }: StatsProps) {
  const shouldReduceMotion = useReducedMotion()
  return (
    <Section>
      <div className="max-w-(--breakpoint-2xl) mx-auto">
        <h2 className="uppercase text-3xl md:text-4xl tracking-[2.5px] text-primaryBlue dark:text-white w-full md:tracking-[3.42px]">
          {heading}
        </h2>
        <div className="relative z-1 flex flex-wrap flex-col mt-12 gap-12">
          {items.map(({ value, valueUnit, stat, lottieUrl, counterDuration, counterDelay, fraction }, index) => (
            <div
              key={index}
              className={cx('w-full lg:w-1/2', index === 1 && `md:self-center`, index === 2 && `md:self-end`)}
            >
              <Stat
                value={value}
                valueUnit={valueUnit}
                fraction={fraction}
                stat={stat}
                counterDuration={counterDuration}
                counterDelay={counterDelay}
                graphic={
                  <Lottie
                    animationData={lottieUrl}
                    autoplayType="Visible"
                    onlyShowFrame={shouldReduceMotion ? 'last' : undefined}
                  />
                }
              />
            </div>
          ))}
        </div>
      </div>
      <div className="hidden md:block absolute top-1/4 right-0 z-0 w-[500px] h-auto [&_svg]:fill-none [&_svg]:w-full">
        <DiamondsRight />
      </div>
    </Section>
  )
}
